import React from "react";
import ListingCard from "../Tazakurat/listingCard";
import SocialHandles from "../SocialHandles/SocialHandles";
import { getStarredArticles } from "./_request";
import { useEffect, useState, useCallback } from "react";

const TazakuraatHighlights = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [widgetKey, setWidgetKey] = useState(Date.now());

  const getArticles = async () => {
    setLoading(true);

    try {
      const response = await getStarredArticles();
      if (response.Result) {
        if (response?.ThisMonthStarred.length > 0) {
          setArticles(response?.ThisMonthStarred);
        } else {
          setArticles(response?.AllStarred);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const reloadElfsightWidget = useCallback(() => {
    try {
      // Clear any existing Elfsight data
      if (window.Elfsight) {
        delete window.Elfsight;
      }

      // Force a re-render of the widget container
      setWidgetKey(Date.now());

      // Add the script if it doesn't exist
      if (
        !document.querySelector(
          'script[src="https://static.elfsight.com/platform/platform.js"]',
        )
      ) {
        const script = document.createElement("script");
        script.src = "https://static.elfsight.com/platform/platform.js";
        script.async = true;
        document.body.appendChild(script);
      }
    } catch (error) {
      console.error("Error reloading Elfsight widget:", error);
    }
  }, []);

  useEffect(() => {
    getArticles();
    reloadElfsightWidget();

    // Add the script on component mount
    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.async = true;
    document.body.appendChild(script);

    // Cleanup function
    return () => {
      if (window.Elfsight) {
        delete window.Elfsight;
      }
    };
  }, [reloadElfsightWidget]);

  return (
    <>
      <div dir="ltr">
        <div className="bg-primaryBG flex flex-col lg:flex-row justify-end px-8 md:px-10 lg:px-[4rem] gap-10 md:gap-6 p-5 sm:p-10 rounded-3xl">
          <div className="w-full lg:w-1/3 order-2 lg:order-1">
            <div className="flex flex-col justify-center items-center">
              <h1 className="text-lg sm:text-xl md:text-xl lg:text-2xl font-nastaleeqKasheeda">
                {/* <span className="bg-primary rounded text-white">انسٹاگرام  </span> */}
                انسٹاگرام پوسٹس
              </h1>
              <div className="w-full mt-6">
                <div key={widgetKey} id="elfsight-container">
                  <div
                    className="elfsight-app-2a9e4bd0-166d-4261-b9de-85f57f8533e2"
                    data-elfsight-app-lazy
                  ></div>
                </div>
                <div className="w-full mt-6 flex justify-center">
                  <SocialHandles />
                </div>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-2/3 order-1 lg:order-2">
            <h1 className="text-lg sm:text-xl md:text-xl lg:text-2xl font-nastaleeqKasheeda text-end">
              {/* اس ماہ<span className="bg-primary rounded text-white"> نمایاں</span> */}
              اس ماہ نمایاں
            </h1>

            {loading ? (
              <div className="flex justify-center items-center h-40">
                <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-primary border-solid"></div>
              </div>
            ) : (
              <div className="pl-5 sm:pl-10 md:pl-10 lg:pl-20">
                {articles?.length > 0 && (
                  <ListingCard data={articles?.slice(0, 4)} />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TazakuraatHighlights;
